import React from "react";

export default function CoinIcon(props) {
  return (
    <svg
      width="80px"
      height="80px"
      viewBox="0 0 80 80"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="business-and-finance">
          <path
            d="M15.81875,63.59375 C15.81875,62.299375 14.769375,61.25 13.475,61.25 L9.375,61.25 C4.205625,61.25 0,65.455625 0,70.625 C0,75.794375 4.205625,80 9.375,80 L24.4484375,80 C25.7428125,80 26.7921875,78.950625 26.7921875,77.65625 L15.81875,63.59375 Z"
            id="coin-icon-Path"
            fill="#3721D2"
          ></path>
          <path
            d="M70.625,61.25 L66.525,61.25 C65.230625,61.25 64.18125,62.299375 64.18125,63.59375 L53.2079687,77.65625 C53.2079687,78.950625 54.2573437,80 55.5517187,80 L70.625,80 C75.794375,80 80,75.794375 80,70.625 C80,65.455625 75.794375,61.25 70.625,61.25 Z"
            id="coin-icon-Path"
            fill="#3721D2"
          ></path>
          <g id="coin-icon-Group" transform="translate(9.531250, 23.750000)">
            <path
              d="M30.46875,0 C13.66875,0 0,13.66875 0,30.46875 C0,40.6953125 5.090625,50.1875 13.61875,55.8578125 C14.003125,56.1140625 14.4546875,56.25 14.9171875,56.25 L27.728125,56.25 L30.46875,54.821875 L30.6765625,54.7140625 L33.2046875,56.25 L46.0203125,56.25 C46.4828125,56.25 46.934375,56.1140625 47.31875,55.8578125 C55.846875,50.1875 60.9375,40.6953125 60.9375,30.46875 C60.9375,13.66875 47.26875,0 30.46875,0 Z"
              id="coin-icon-Path"
              fill="#FABE2C"
            ></path>
            <path
              d="M60.9375,30.46875 C60.9375,40.6953125 55.846875,50.1875 47.31875,55.8578125 C46.934375,56.1140625 46.4828125,56.25 46.0203125,56.25 L33.2046875,56.25 L30.6765625,54.7140625 L30.46875,54.821875 L30.46875,0 C47.26875,0 60.9375,13.66875 60.9375,30.46875 Z"
              id="coin-icon-Path"
              fill="#FF9100"
            ></path>
            <path
              d="M56.25,30.46875 C56.25,43.05625 47.1328125,54.3296875 33.2046875,56.25 L27.728125,56.25 C13.803125,54.328125 4.6875,43.05625 4.6875,30.46875 C4.6875,16.253125 16.253125,4.6875 30.46875,4.6875 C44.684375,4.6875 56.25,16.253125 56.25,30.46875 Z"
              id="coin-icon-Path"
              fill="#FED843"
            ></path>
            <path
              d="M56.25,30.46875 C56.25,43.05625 47.1328125,54.3296875 33.2046875,56.25 L30.46875,56.25 L30.46875,4.6875 C44.684375,4.6875 56.25,16.253125 56.25,30.46875 Z"
              id="coin-icon-Path"
              fill="#FABE2C"
            ></path>
          </g>
          <path
            d="M47.03125,58.90625 C47.03125,61.9609375 45.071875,64.5671875 42.34375,65.534375 L42.34375,68.28125 C42.34375,69.575 41.29375,70.625 40,70.625 C38.70625,70.625 37.65625,69.575 37.65625,68.28125 L37.65625,65.534375 C34.928125,64.5671875 32.96875,61.9609375 32.96875,58.90625 C32.96875,57.6125 34.01875,56.5625 35.3125,56.5625 C36.60625,56.5625 37.65625,57.6125 37.65625,58.90625 C37.65625,60.1984375 38.7078125,61.25 40,61.25 C41.2921875,61.25 42.34375,60.1984375 42.34375,58.90625 C42.34375,57.6140625 41.2921875,56.5625 40,56.5625 C36.1234375,56.5625 32.96875,53.4078125 32.96875,49.53125 C32.96875,46.4765625 34.928125,43.8703125 37.65625,42.903125 L37.65625,40.15625 C37.65625,38.8625 38.70625,37.8125 40,37.8125 C41.29375,37.8125 42.34375,38.8625 42.34375,40.15625 L42.34375,42.903125 C45.071875,43.8703125 47.03125,46.4765625 47.03125,49.53125 C47.03125,50.825 45.98125,51.875 44.6875,51.875 C43.39375,51.875 42.34375,50.825 42.34375,49.53125 C42.34375,48.2390625 41.2921875,47.1875 40,47.1875 C38.7078125,47.1875 37.65625,48.2390625 37.65625,49.53125 C37.65625,50.8234375 38.7078125,51.875 40,51.875 C43.8765625,51.875 47.03125,55.0296875 47.03125,58.90625 Z"
            id="coin-icon-Path"
            fill="#FABE2C"
          ></path>
          <path
            d="M47.03125,58.90625 C47.03125,61.9609375 45.071875,64.5671875 42.34375,65.534375 L42.34375,68.28125 C42.34375,69.575 41.29375,70.625 40,70.625 L40,61.25 C41.2921875,61.25 42.34375,60.1984375 42.34375,58.90625 C42.34375,57.6140625 41.2921875,56.5625 40,56.5625 L40,51.875 C43.8765625,51.875 47.03125,55.0296875 47.03125,58.90625 Z"
            id="coin-icon-Path"
            fill="#FF9100"
          ></path>
          <path
            d="M40,47.1875 L40,37.8125 C41.29375,37.8125 42.34375,38.8625 42.34375,40.15625 L42.34375,42.903125 C45.071875,43.8703125 47.03125,46.4765625 47.03125,49.53125 C47.03125,50.825 45.98125,51.875 44.6875,51.875 C43.39375,51.875 42.34375,50.825 42.34375,49.53125 C42.34375,48.2390625 41.2921875,47.1875 40,47.1875 Z"
            id="coin-icon-Path"
            fill="#FF9100"
          ></path>
          <path
            d="M42.34375,7.03125 L42.34375,16.40625 C42.34375,17.7 41.29375,18.75 40,18.75 C38.70625,18.75 37.65625,17.7 37.65625,16.40625 L37.65625,7.03125 C37.65625,5.7375 38.70625,4.6875 40,4.6875 C41.29375,4.6875 42.34375,5.7375 42.34375,7.03125 Z"
            id="coin-icon-Path"
            fill="#DFE7F4"
          ></path>
          <path
            d="M42.34375,7.03125 L42.34375,16.40625 C42.34375,17.7 41.29375,18.75 40,18.75 L40,4.6875 C41.29375,4.6875 42.34375,5.7375 42.34375,7.03125 Z"
            id="coin-icon-Path"
            fill="#C7CFE1"
          ></path>
          <path
            d="M49.375,14.0625 C48.080625,14.0625 47.03125,13.013125 47.03125,11.71875 L47.03125,2.34375 C47.03125,1.049375 48.080625,0 49.375,0 C50.669375,0 51.71875,1.049375 51.71875,2.34375 L51.71875,11.71875 C51.71875,13.013125 50.669375,14.0625 49.375,14.0625 Z"
            id="coin-icon-Path"
            fill="#C7CFE1"
          ></path>
          <path
            d="M30.625,14.0625 C29.330625,14.0625 28.28125,13.013125 28.28125,11.71875 L28.28125,2.34375 C28.28125,1.049375 29.330625,0 30.625,0 C31.919375,0 32.96875,1.049375 32.96875,2.34375 L32.96875,11.71875 C32.96875,13.013125 31.919375,14.0625 30.625,14.0625 Z"
            id="coin-icon-Path"
            fill="#DFE7F4"
          ></path>
        </g>
      </g>
    </svg>
  );
}
